export default {
  styleOverrides: {
    dense: {
      height: 45,
      minHeight: 45,
      paddingRight: 20,
      paddingLeft: 20,
    },
  },
};
